module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavyrain-ce639d188c3f3f659f105d333f02c28e.svg";